<div class="content-grid" [class.detail]="isDetail()">
  <div class="column">
    @if (epsData()) {
      <div class="chart-header">
        <span class="chart-title">Earnings per Share</span>
        <span class="chart-subtitle">in {{ epsSymbol() }} · je Quartal</span>
      </div>
      <app-eps-chart
        [data]="epsData()"
        [v3]="true"
        [animateIn]="true"
        [legend]="false"
        [steps]="3"
      ></app-eps-chart>
      <div class="chart-footer">
        <div class="footer-legend">
          <span class="legend-item">
            <span class="legend-dot reported"></span>
            <span class="legend-label">Meldung</span>
          </span>
          <span class="legend-item">
            <span class="legend-dot expected"></span>
            <span class="legend-label">Erwartung</span>
          </span>
        </div>
        <p class="footer-source">Quelle: {{ dataSources.FACTSET }}</p>
      </div>
    }

    @if (quarterSurprisePercent() !== null) {
      @if (isFinnet()) {
        <div class="quarter-stat">
          <ng-container [ngTemplateOutlet]="quarterStatContent"></ng-container>
        </div>
      } @else {
        <app-v3-notch-card
          class="quarter-stat-card"
          [notchColor]="quarterSurpriseBeat() ? 'var(--v3-positive)' : 'var(--v3-negative)'"
        >
          <div class="quarter-stat-row">
            <ng-container [ngTemplateOutlet]="quarterStatContent"></ng-container>
          </div>
        </app-v3-notch-card>
      }
    }

    <ng-content select="[left-column]"></ng-content>
  </div>
  <div class="divider"></div>
  <div class="column">
    @if (isEarningsDateEnabled()) {
      @if (isFinnet()) {
        <div class="agenda-stat">
          <ng-container [ngTemplateOutlet]="agendaStatContent"></ng-container>
        </div>
      } @else {
        <app-v3-notch-card class="agenda-stat-card" notchColor="var(--v3-primary)">
          <div class="agenda-stat-row">
            <ng-container [ngTemplateOutlet]="agendaStatContent"></ng-container>
          </div>
        </app-v3-notch-card>
      }
    }

    @if (revenueStats()) {
      <span class="revenue-title">Umsatz und Gewinn</span>
      <app-revenue-chart [earningsStats]="revenueStats()" [v3]="true"></app-revenue-chart>
    }

    <ng-content select="[right-column]"></ng-content>
  </div>
</div>

<ng-template #quarterStatContent>
  <div class="quarter-stat-text">
    <span class="quarter-stat-title">Zum letzten Quartal</span>
    <span class="quarter-stat-subtitle">
      Gewinn vs. Erwartung
      @if (fiscalPeriod()) {
        · {{ fiscalPeriod() }}
      }
      @if (updatedAt()) {
        · <app-time-ago [updatedAt]="updatedAt()" format="minimal"></app-time-ago>
      }
    </span>
  </div>
  <span class="quarter-stat-value-group" [class.negative]="!quarterSurpriseBeat()">
    <span class="quarter-stat-value" [appCountUp]="quarterSurprisePercent()!"></span>
    <span class="quarter-stat-unit">%</span>
  </span>
</ng-template>

<ng-template #agendaStatContent>
  <div class="agenda-text">
    <span class="agenda-title">Nächster Earnings-Termin</span>
    <span class="agenda-subtitle">{{ nextEarningsReportLabel() }}</span>
  </div>
  <span class="agenda-date">{{ nextEarningsDate }}</span>
</ng-template>
